/* HDK shared: reveal-on-scroll for any .hdk-reveal element */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.hdk-reveal').forEach(function (el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.hdk-reveal').forEach(function (el) { io.observe(el); });
})();
